import { Box, Typography } from '@mui/material';
import React from 'react';
import { useGetDashboardTasksStats } from '../../../services/react-query/dashboard/useGetDashboardTasksStats';
import { Loading } from '../../../uikit';
import { footerContainerStyles, footerCountDivStyles, footerCountProps, footerLabelProps } from '../dashboardStyles';

interface ITaskFooterProps {
  employee?: string;
}

export function TaskFooter({ employee }: ITaskFooterProps) {
  const { data, isLoading } = useGetDashboardTasksStats({ params: { filters: { employee: employee ? [employee] : undefined } } });

  if (isLoading || !data) return <Loading />;

  return (
    <Box sx={footerContainerStyles}>
      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{data.task_overdue}</Typography>
        <Typography align="center" {...footerLabelProps}>
          Overdue
        </Typography>
      </Box>
      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{data.task_due_today}</Typography>
        <Typography align="center" {...footerLabelProps}>
          Task Due Today
        </Typography>
      </Box>
    </Box>
  );
}
